module.exports = __webpack_public_path__ + "static/media/Red-Onion-Foods.d3a65ac7.png";